<div class="create-user">
    <!-- Form Container -->
    <div class="container-custom">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
            </div>
            <span class="fa fa-times close_icon" (click)="closeModal()"></span>
        </div>
        <div class="d-flex justify-content-between align-items-center user-header">
            <div>
                <span class="title">Create User</span>
            </div>
            <span class="step-info">Step 3 of 3</span>
        </div>
        <div class="row" *ngIf="branchId && rowData && rowData.length > 0">
            <span style="margin-top: 1.75rem;" class="mb-3">Existing User(s)</span>
            <div class="col-md-12">            
                <ag-grid-angular style="width: 100%; height: 130px;" class="ag-theme-alpine" [theme]="'legacy'" [rowData]="rowData"
                    [columnDefs]="columnDefs" [modules]="modules" [animateRows]="true" [pagination]="pagination"
                    [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="false" [domLayout]="'autoHeight'"
                    [gridOptions]="gridOptions" rowDragManaged="false" animateRows="true" (gridReady)="onGridReady($event)" #agGrid>
                </ag-grid-angular>
            </div>
        </div>
        <confirm-dialog (confirm)="onConfirmDelete()"></confirm-dialog>
        <ng-template #cellTemplate let-value="value" let-rowData="rowData">
            <div class="action-container">
                <div class="menu-dropdown">
                    <button class="btn" type="button" (click)="editRow(rowData)">✏️ </button>
                    <button class="btn" type="button" (click)="deleteRow(rowData)">🗑️</button>
                </div>
            </div>
        </ng-template>
        <div class="my-4">
            <p>Please fill the below information to create a user.</p>
        </div>
        <!-- Form Fields -->
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="form-label">First Name*</label>
                    <input type="text" class="form-control" placeholder="Enter First Name"
                        formControlName="first_name">
                    <small *ngIf="userForm.get('first_name')?.invalid && userForm.get('first_name')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('first_name')?.errors?.['required']">First name is
                            required.</span>
                        <span *ngIf="userForm.get('first_name')?.errors?.['maxlength']">First name cannot
                            exceed 150 characters.</span>
                    </small>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Last Name*</label>
                    <input type="text" class="form-control" placeholder="Enter Last Name"
                        formControlName="last_name">
                    <small *ngIf="userForm.get('last_name')?.invalid && userForm.get('last_name')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('last_name')?.errors?.['required']">Last name is
                            required.</span>
                        <span *ngIf="userForm.get('last_name')?.errors?.['maxlength']">Last name cannot
                            exceed 150 characters.</span>
                    </small>
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Username*</label>
                    <input type="text" class="form-control" placeholder="Enter Username"
                        formControlName="username">
                    <small *ngIf="userForm.get('username')?.invalid && userForm.get('username')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('username')?.errors?.['required']">Username is
                            required.</span>
                        <span *ngIf="userForm.get('username')?.errors?.['minlength']">Username must be at least 3 characters.</span>
                        <span *ngIf="userForm.get('username')?.errors?.['maxlength']">Username cannot
                            exceed 50 characters.</span>
                        <span *ngIf="userForm.get('username')?.errors?.['pattern']">Username must be
                            3-50 chars and only lowercase letters, numbers, dot (.), underscore (_) or hyphen (-).</span>
                    </small>
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Password*</label>
                    <input type="text" class="form-control" placeholder="Enter Password"
                        formControlName="password">
                    <small *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('password')?.errors?.['required']">Password is
                            required.</span>
                        <span *ngIf="userForm.get('password')?.errors?.['minlength']">Password must be at least 8 characters.</span>
                        <span *ngIf="userForm.get('password')?.errors?.['maxlength']">Password cannot
                            exceed 128 characters.</span>
                        <span *ngIf="userForm.get('password')?.errors?.['pattern']">Password must include uppercase, lowercase, number, and special character.</span>
                    </small>
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Contact Number*</label>
                    <input type="text" class="form-control" placeholder="Enter Contact Number" formControlName="mobile">
                    <small *ngIf="userForm.get('mobile')?.invalid && userForm.get('mobile')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('mobile')?.errors?.['required']">Contact number is required.</span>
                        <span *ngIf="userForm.get('mobile')?.errors?.['maxlength']">Contact number cannot
                            exceed 50 characters.</span>
                    </small>
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Contact Email*</label>
                    <input type="email" class="form-control" placeholder="Enter Email Address" formControlName="email">
                    <small *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('email')?.errors?.['required']">Contact email is required.</span>
                        <span *ngIf="userForm.get('email')?.errors?.['email'] || userForm.get('email')?.errors?.['pattern']">Please enter a valid email address.</span>
                    </small>
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Upload Profile Picture</label>
                    <input type="file" class="form-control" (change)="onProfileFileSelected($event)">
                    <div *ngIf="logoPreview" class="mt-3">
                        <img [src]="logoPreview" alt="logo" class="img-thumbnail" style="width: 40px; height: 40px;">
                    </div>
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Upload Signature</label>
                    <input type="file" class="form-control" (change)="onSignatureFileSelected($event)">
                    <div *ngIf="signaturePreview" class="mt-3">
                        <img [src]="signaturePreview" alt="logo" class="img-thumbnail" style="width: 40px; height: 40px;">
                    </div>
                </div>
              
                <div class="col-md-6 mt-3">
                    <label class="form-label">Assign Organisation(s)*</label>
                    <!-- <select class="form-control" (change)="onOrganisationChange($event)" formControlName="organisation_id">
                        <option [ngValue]="null" disabled selected>Select Organization</option>               
                        <option *ngFor="let org of organizationsList" [value]="org.id">
                            {{ org.name }}
                        </option>
                    </select> -->

                    <app-single-select-dropdown
                        [list]="organizationsList || []"
                        [displayKey]="'name'"
                        [valueKey]="'id'"
                        [placeholder]="'Select Organisation'"
                        formControlName="organisation_id"
                        (selectionChange)="onOrganisationChange($event)"></app-single-select-dropdown>
                    <small *ngIf="userForm.get('organisation_id')?.invalid && userForm.get('organisation_id')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('organisation_id')?.errors?.['required']">Organisation is required.</span>
                    </small>
                </div>

                <div class="col-md-6 mt-3">
                    <label class="form-label">Assign Module*</label>
                     <app-multiselect-dropdown formControlName="module_id" [list]="moduleList|| []"
                        [displayKey]="'name'" [valueKey]="'id'" placeholder=" Modules">
                    </app-multiselect-dropdown>
                    <small *ngIf="userForm.get('module_id')?.invalid && userForm.get('module_id')?.touched" class="text-danger">
                        <span *ngIf="userForm.get('module_id')?.errors?.['required']">Module is required.</span>
                    </small>
                </div>
                <div class="col-md-6 mt-3">
                <label class="form-label">MCI Number</label>
                <input type="text" class="form-control" placeholder="Enter MCI number" formControlName="mci_number">
                </div>
                <div class="col-md-6 mt-3">
                <label class="form-label">Enter Specialization</label>
                <textarea class="form-control" placeholder="Enter Specialization" rows="3" formControlName="specialisation"></textarea>
                <small *ngIf="userForm.get('specialisation')?.invalid && userForm.get('specialisation')?.touched" class="text-danger">
                <span *ngIf="userForm.get('specialisation')?.errors?.['maxlength']">Specialization cannot exceed 500 characters.</span>
                </small>
                </div>
                <div class="col-md-12 mt-3">
                <label class="form-label">Qualifications</label>
                <textarea class="form-control" placeholder="Enter qualification" rows="3" formControlName="qualification"></textarea>
                </div>
                <div class="col-md-6 mt-3">
                <label class="form-label">Year of Passing (MBBS)</label>
                <input type="date" class="form-control" placeholder="Year of Passing" formControlName="year_of_passing">
                </div>
                <div class="col-md-6 ">
                  <label class="form-label">Doctor Tag*</label>
                     <app-multiselect-dropdown formControlName="tag_id" [list]="tagList || []"
                        [displayKey]="'name'" [valueKey]="'id'" placeholder="Doctor Tag">
                     </app-multiselect-dropdown>
                    <small *ngIf="userForm.get('tag_id')?.invalid && userForm.get('tag_id')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('tag_id')?.errors?.['required']"> Doctor Tag is required.</span>
                    </small>
                </div>
             <div class="col-md-6 ">
                <label class="form-label">Global Tag*</label>
                <app-multiselect-dropdown formControlName="global_tag_id" [list]="globalTagList || []"
                        [displayKey]="'tag_name'" [valueKey]="'id'" placeholder="Global Tag">
                </app-multiselect-dropdown>
                <small *ngIf="userForm.get('global_tag_id')?.invalid && userForm.get('global_tag_id')?.touched"
                        class="text-danger">
                        <span *ngIf="userForm.get('global_tag_id')?.errors?.['required']"> Global Tag is required.</span>
                </small>
               </div>
                <div class="col-md-12 mt-3">
                    <label class="form-label">Patient Tags</label>
                    <input type="text" class="form-control" placeholder="Search for tags" formControlName="patient_tags">
                </div>
            </div>

            <!-- Toggles -->
            <div class="mt-3">
                <div class="d-flex align-items-center mb-2">
                    <label class="form-check-label me-2">Active Status</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_active">
                    </div>
                </div>
            </div>

            <!-- Buttons -->
            <div class="footer-buttons mt-3 mb-2">
                <!-- <button class="btn btn-save" type="submit">Save</button> -->
                <div class="d-flex align-items-center mt-5 gap-3">
                    <button class="btn btn-outline-secondary" (click)="closeModal()" type="button">Cancel</button>
                    <button class="btn btn-create" type="submit">Submit</button>
                    <button class="btn btn-save" *ngIf="userData?.id" (click)="createAnotherUser()" type="button">Create another user</button>
                </div>
            </div>
        </form>
    </div>
</div>
